import dd from 'DD'
export function getUser () {
  if (window.location.host.indexOf('fosun') === -1 && (dd.env.platform !== 'notInDingTalk')) {
    return {
      mobile1: '18017569919'
    }
  }
  if (dd.env.platform === 'notInDingTalk') {
    return {
      mobile1: '18221734105'
      // mobile1: 18521099011 // 陈伟光
      // mobile1: '18715124118' // 张金
      // mobile1: 15801777183 // 陈诗雨
      // const testPhone = "18601701917"; // 钱亮
      //       // const testPhone = "15262908661"; // 吕鹏飞
      //       //   const testPhone = "17317326820"; // 谭越
      //       //   const testPhone = "15701656913"; // 谢浩
      //       // const testPhone = '15606100808' // 朱宇菲
      //       // const testPhone = "18017569919"; // 高总
      //       //   const testPhone = "13262727079"; // 陶前金
      //       // const testPhone = "13512121606"; // 文佳
      //       // const testPhone = "15088600698"; // 张珍
      //       // const testPhone = "18221734105"; // 黄婷
      //       // const testPhone = "13601769193"; //    仇
      //       //   const testPhone = "13986154581"; // test
      //       //   const testPhone = "15901241803"; // test
      //       // const testPhone = "13816422253"; // 豫园 王湛
      //       // const testPhone = "18001648846"; // 豫园 rita
    }
  }
  return new Promise((resolve, reject) => {
    // 获取当前用户信息
    window.fosun_oapi_login.getDDAccount({
      onSuccess: function (_userInfo) {
        resolve(_userInfo)
      },
      onFail: function (err) {
        // alert(JSON.stringify(err))
        reject(err)
      }
    })
  })
}

export function previewImage (imgs, index = 0, otherCallback) {
  if (!Array.isArray(imgs)) {
    imgs = [imgs]
  }
  if (dd.env.platform !== 'notInDingTalk') {
    dd.biz.util.previewImage({
      urls: imgs, // 图片地址列表
      current: imgs[index], // 当前显示的图片链接
      onSuccess: function (result) {
      /**/
      }
    })
  } else {
    if (otherCallback) {
      otherCallback()
    }
  }
}
